import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialize-writing',
  templateUrl: './specialize-writing.component.html',
  styleUrls: ['./specialize-writing.component.scss']
})
export class SpecializeWritingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
